module.exports = __webpack_public_path__ + "img/product-6-INTreport.586f659e.png";